import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import FlagIcon from "@material-ui/icons/Flag";
import NotesIcon from "@material-ui/icons/Notes";

export const sessionNoteTypes = [
  {
    type_id: 1,
    value: 1,
    label: "createSession.keyPoint",
    icon: <FlagIcon />,
    color: "#4E2EE6",
    likable: false,
  },
  {
    type_id: 3,
    value: 3,
    label: "createSession.compliment",
    icon: <EmojiEventsIcon />,
    color: "#FF9C12",
    likable: true,
  },
  {
    type_id: 2,
    value: 2,
    label: "createSession.casualNote",
    icon: <NotesIcon />,
    color: "#2B7EFB",
    likable: false,
  },
];
